module.exports = __webpack_public_path__ + "static/media/Patricia.489c82fd.jpg";